/* Mobile filter UX: on product-listing pages, collapse the inline filter
   sidebar into a "Filters" button that opens a bottom-sheet. Sort stays a
   native <select> (its picker is the popup). Runs only where a filter aside
   with checkboxes exists; no-ops everywhere else.

   IMPORTANT: the sheet is built ONLY at mobile widths (<=768px). Desktop is
   left completely untouched — no injected "Filters"/close/"Show results"
   chrome, and the aside keeps its own inline sticky positioning + reveal
   animation. (Previously init ran on every viewport and relied on CSS alone
   to hide the mobile chrome, which leaked a duplicate "Filters ×" header onto
   desktop and stripped the sidebar's sticky style.) If the viewport is later
   resized down into mobile, the sheet is built lazily at that point. */
(function () {
  var mq = window.matchMedia('(max-width: 768px)');

  function build() {
    if (window.__mfsInit) return;
    var aside = document.querySelector('section aside');
    // Only real Shopify storefront filters (inputs named filter.*). A bare checkbox is not enough:
    // the product page's buy column is also a <section><aside>, and its Notify-me opt-in checkbox
    // used to turn it into a bogus "Filters" sheet on phones.
    if (!aside || !aside.querySelector('input[name^="filter."], [data-filter]')) return;

    var grid = aside.parentElement;
    var products = null;
    for (var i = 0; i < grid.children.length; i++) {
      if (grid.children[i] !== aside) { products = grid.children[i]; break; }
    }
    if (!products) return;
    window.__mfsInit = true;

    // "Filters" button → injected into the existing count/sort toolbar row
    var toolbar = products.firstElementChild;
    var fBtn = document.createElement('button');
    fBtn.type = 'button';
    fBtn.className = 'mfs-btn';
    fBtn.setAttribute('aria-expanded', 'false');
    fBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 5h18M6 12h12M10 19h4"/></svg>Filters';
    if (toolbar) { toolbar.insertBefore(fBtn, toolbar.firstChild); toolbar.classList.add('mfs-toolbar'); }
    else products.insertBefore(fBtn, products.firstChild);

    // Turn the aside into a bottom-sheet (clear its inline sticky positioning)
    aside.removeAttribute('style');
    aside.classList.remove('reveal'); // the reveal animation's transform/opacity fights the sheet
    aside.classList.add('mfs-sheet');
    var head = document.createElement('div');
    head.className = 'mfs-head';
    head.innerHTML = '<span>Filters</span><button type="button" class="mfs-close" aria-label="Close filters">&times;</button>';
    aside.insertBefore(head, aside.firstChild);
    var form = aside.closest('form');
    var apply = document.createElement('button');
    // Inside the filter form this submits (applies price + any pending changes);
    // as a fallback outside a form it just closes the sheet.
    apply.type = form ? 'submit' : 'button';
    apply.className = 'mfs-apply';
    apply.textContent = 'Show results';
    aside.appendChild(apply);

    var backdrop = document.createElement('div');
    backdrop.className = 'mfs-backdrop';
    document.body.appendChild(backdrop);

    function open() {
      aside.classList.add('is-open'); backdrop.classList.add('show');
      document.body.classList.add('mfs-lock'); fBtn.setAttribute('aria-expanded', 'true');
    }
    function close() {
      aside.classList.remove('is-open'); backdrop.classList.remove('show');
      document.body.classList.remove('mfs-lock'); fBtn.setAttribute('aria-expanded', 'false');
    }
    fBtn.addEventListener('click', open);
    backdrop.addEventListener('click', close);
    apply.addEventListener('click', close);
    head.querySelector('.mfs-close').addEventListener('click', close);
    window.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function maybeBuild() { if (mq.matches) build(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maybeBuild);
  else maybeBuild();
  // Build lazily if the viewport is later resized down into mobile.
  if (mq.addEventListener) mq.addEventListener('change', maybeBuild);
  else if (mq.addListener) mq.addListener(maybeBuild); // older Safari fallback
})();
